module.exports = __webpack_public_path__ + "img/svg/new.228c3a025cac7fd98bc7867651d42a47.svg";